/**
 * Flag central de telas do Supervisor prontas (Brief 3 V2 — execução faseada).
 * Drill-downs para telas com flag=false renderizam disabled state "em breve".
 */
export type SupervisorScreenId =
  | 'painel-equipe'
  | 'acompanhamento'
  | 'intervencao'
  | 'inbox-time'
  | 'painel-sla'
  | 'dashboard-qualidade'
  | 'centro-alertas'
  | 'painel-p1'
  | 'aprovacao-overrides'
  | 'insights';

export const SUPERVISOR_SCREENS_READY: Record<SupervisorScreenId, boolean> = {
  'painel-equipe': true,
  acompanhamento: true,
  intervencao: true,
  'inbox-time': true,
  'painel-sla': true,
  'dashboard-qualidade': true,
  'centro-alertas': true,
  'painel-p1': true,
  'aprovacao-overrides': true,
  insights: true,
};

export function isScreenReady(id: SupervisorScreenId): boolean {
  return SUPERVISOR_SCREENS_READY[id];
}
